import { atom, useAtom, getDefaultStore } from 'jotai'

const proposalResultAtom = atom(null)

const useProposalResult = () => useAtom(proposalResultAtom)

export const getProposalResult = () => getDefaultStore().get(proposalResultAtom)

export const setProposalResult = (value) => {
  getDefaultStore().set(proposalResultAtom, value)
}

export default useProposalResult
